import C from '../constants';

const { STATE } = C;

export default {
  id: { required: true, disabled: true, style: 'inline5' },
  activityId: { required: true, style: 'inline5' },
  state: {
    type: 'select', defaultValue: STATE.EXPERIENCE[1], dataSource: STATE.EXPERIENCE, style: 'inline5',
  },
  fee: {
    type: 'select', defaultValue: STATE.FEE[0], dataSource: STATE.FEE, style: 'inline5',
  },
  available: { type: 'bool', style: 'inline5' },
  name: { required: true, style: 'inline2' },
  summary: { lines: 2 },
  description: { lines: 10 },
  image: { type: 'image' },
  categories: { type: 'list', style: 'inline2' },
  gallery: { type: 'list', style: 'inline2' },
  provider: {
    title: 'Provider',
    attributes: {
      id: { style: 'inline3' },
      name: { style: 'inline3' },
      clickout: { type: 'bool', style: 'inline3' },
      logo: { type: 'image', style: 'inline2' },
      stripe: { style: 'inline2' },
    },
  },
  location: {
    title: 'Location',
    attributes: {
      lat: { keyboard: 'numeric', label: 'Latitude', style: 'inline2' },
      lon: { keyboard: 'numeric', label: 'Longitude', style: 'inline2' },
    },
    style: 'inline2',
  },
  people: {
    title: 'People',
    attributes: {
      min: { keyboard: 'numeric', style: 'inline2' },
      max: { keyboard: 'numeric', style: 'inline2' },
    },
    style: 'inline2',
  },
};

// prices: [{
//   value: Number,
//   currency: { type: String, enum: Object.values(E.CURRENCY) },
//   type: { type: String, enum: Object.values(E.INDIVIDUAL) },
//   title: l10n,
//   caption: l10n,
// }],
// calendars: [{ type: mongoose.Schema.Types.ObjectId, ref: 'Calendar' }],
// addons: [{ type: mongoose.Schema.Types.ObjectId, ref: 'Addon' }],
// created: { type: Date, default: Date.now },
// updated: { type: Date },
